import { jsonValueSchema } from '@pesto/utils';
import { z } from 'zod';

import type { StatementListItem } from '../types/Statements.types';

type RawStatement = Omit<StatementListItem, 'pdfDataSnapshot'> & {
  pdfDataSnapshot?: unknown;
  loan?: { id?: string | null; partnerAccountNumber?: string | null } | null;
};

const snapshotJsonSchema = z.record(jsonValueSchema).nullish();

export const toStatementListItem = <T extends RawStatement>(statement: T): StatementListItem => ({
  id: statement.id,
  billingPeriodStart: statement.billingPeriodStart,
  billingPeriodEnd: statement.billingPeriodEnd,
  dueDate: statement.dueDate,
  previousBalance: statement.previousBalance,
  totalPayments: statement.totalPayments,
  otherCredits: statement.otherCredits,
  totalPurchases: statement.totalPurchases,
  cashAdvance: statement.cashAdvance,
  interestCharged: statement.interestCharged,
  feesCharged: statement.feesCharged,
  newBalance: statement.newBalance,
  creditLimit: statement.creditLimit,
  creditLimitAvailable: statement.creditLimitAvailable,
  minimumPaymentDue: statement.minimumPaymentDue,
  ytdFeesCharged: statement.ytdFeesCharged,
  ytdInterestCharged: statement.ytdInterestCharged,
  insertedAt: statement.insertedAt,
  updatedAt: statement.updatedAt,
  closingBalance: statement.closingBalance ?? null,
  interestApplied: statement.interestApplied ?? null,
  lateFeeApplied: statement.lateFeeApplied ?? null,
  pdfFilename: statement.pdfFilename ?? null,
  hasPdf: statement.hasPdf ?? null,
  pdfDataSnapshot: snapshotJsonSchema.parse(statement.pdfDataSnapshot),
  purchaseBalanceAtPeriodEnd: statement.purchaseBalanceAtPeriodEnd ?? null,
  drawdownBalanceAtPeriodEnd: statement.drawdownBalanceAtPeriodEnd ?? null,
  interestBalanceAtPeriodEnd: statement.interestBalanceAtPeriodEnd ?? null,
  feeBalanceAtPeriodEnd: statement.feeBalanceAtPeriodEnd ?? null,
  repaymentBalanceAtPeriodEnd: statement.repaymentBalanceAtPeriodEnd ?? null,
  averageDailyBalance: statement.averageDailyBalance ?? null,
  graceSavings: statement.graceSavings ?? null,
  newPurchaseBalanceAtPeriodEnd: statement.newPurchaseBalanceAtPeriodEnd ?? null,
  statementDate: statement.statementDate ?? null,
  graceActive: statement.graceActive ?? null,
  previousBalancePaidInFull: statement.previousBalancePaidInFull ?? null,
  loanId: statement.loan?.id ?? statement.loanId ?? null,
  loanPartnerAccountNumber: statement.loan?.partnerAccountNumber ?? statement.loanPartnerAccountNumber ?? null,
  lateFeeEligibleOn: statement.lateFeeEligibleOn ?? null,
  dueDateProcessedAt: statement.dueDateProcessedAt ?? null,
  lateFeeProcessedAt: statement.lateFeeProcessedAt ?? null,
  autopayProcessedAt: statement.autopayProcessedAt ?? null,
  pdfGeneratedAt: statement.pdfGeneratedAt ?? null,
});
